module.exports = {
  coSubReminderComponentEvents: {
    RemindCoSubRegistration: {
      code: 'CSEmail',
      events: {
        Dialog: {
          description: 'Triggered when Send Reminder or Maybe Later is clicked on Remind Co-sub Registration dialog.',
          eventHub: {
            code: 'Dialog',
            action: 'CS_Email_[$.action]_Clicked',
            dataKeys: ['action']
          }
        }
      }
    },
    RemindCoSubDialogLoad: {
      code: 'CSEmailPageLoaded',
      events: {
        Dialog: {
          description: 'Triggered when RemindCoSubDialog is loaded',
          eventHub: {
            code: 'Dialog',
            action: 'CS_Email_Page_Loaded'
          }
        }
      }
    },
    RemindCoSubBanner: {
      code: 'CSEmailInviteClicked',
      events: {
        Banner: {
          description: 'Triggered when Invite CTA is clicked on RESP Dashboard',
          eventHub: {
            code: 'Banner',
            action: 'CS_Email_Invite_Clicked'
          }
        }
      }
    }
  }
};
